module.exports = __webpack_public_path__ + "img/cw13.af19d1fa.jpg";